module.exports = __webpack_public_path__ + "img/RED_BACK.efe55855.svg";